import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Menu from './views/Menu.vue'
import VistaPedido from './views/VistaPedido.vue'
import VistaFacturas from './views/VistaFacturas.vue'
import UpdateFailView from './views/UpdateFailView.vue'
import TpvAuth from './views/TpvAuth.vue'
import facturasPendientes from './components/facturasPendientes.vue'
import VistaRutas from './views/VistaRutas.vue'
import VistaVisita from './views/VistaVisita.vue'
import VistaBlank from './views/VistaBlank.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/tpvAuth',
      name: 'tpvAuth',
      component: TpvAuth
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/menu',
      name: 'menu',
      component: Menu
    },
    {
      path: '/pedido',
      name: 'pedido',
      component: VistaPedido
    },
    {
      path: '/facturas',
      name: 'facturas',
      component: VistaFacturas
    },
    {
      path: '/updateFail',
      name: 'updateFail',
      component: UpdateFailView
    },
    {
      path: '/rutas',
      name: 'rutas',
      component: VistaRutas
    },
    {
      path: '/nuevavisita',
      name: 'nuevavisita',
      component: VistaVisita
    },
    {
      path: '/editarvisita',
      name: 'editarvisita',
      component: VistaVisita
    },
    {
      path: '/sinpedido',
      name: 'sinpedido',
      component: VistaVisita
    },
    {
      path: '/comentarios',
      name: 'comentarios',
      component: VistaVisita
    },
    {
      path: '/test',
      name: 'test',
      component: facturasPendientes
    }
  ]
})
